import { Game } from '@repo/types'
import { ToggleSwitch } from '@repo/ui'
import { observer } from 'mobx-react-lite'
import React from 'react'

import { useGameContext } from '@/pages/game/context/game-context'
import { updateGameSetting } from '@/store/game/updateGameDocument'

import { SettingsRow } from './SettingsRow'

const SETTING_NAME = 'Highlight Current Column'
const SETTING_ID = 'highlightColumns' as const

export const PlayerCardHighlighting = observer(
  function PlayerCardHighlighting(): React.ReactElement {
    const { gameData, gameId, tracker } = useGameContext()

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      const { checked } = event.target

      const update: Pick<Game, typeof SETTING_ID> = {
        [SETTING_ID]: checked
      }

      void updateGameSetting(gameId, update)
      tracker.changeToggle(SETTING_NAME, checked)
    }

    return (
      <SettingsRow
        description={`Show guests which column the current song is under. If you're experiencing delay, you may want to switch this off.`}
        heading={SETTING_NAME}
      >
        <ToggleSwitch
          id={SETTING_ID}
          isChecked={gameData.highlightColumns}
          isDisabled={!gameData}
          onChange={handleChange}
        />
      </SettingsRow>
    )
  }
)
